export default __webpack_public_path__ + "static/media/no-events.26089d22.png";